<div *ngIf="showBanner" class="maintenance-banner d-flex flex-row vi-gap-16">
  <div>
    <mat-icon aria-hidden="false" aria-label="info icon">info</mat-icon>
  </div>
  <div>{{
      'COMMON.MAINTENANCE.MESSAGE.PLANNED' | translate: {
        from: next_maintenance.start_date | date : 'medium' : timezone : locale,
        until: next_maintenance.end_date | date : 'medium': timezone : locale,
      }
    }}
  </div>
</div>

